import { Controller } from "@hotwired/stimulus";

import Choices from "choices.js";

export default class extends Controller {
  static targets = ["choice", "toggler"];
  static values = {
    options: String,
    removeItemButton: Boolean,
    searchEnabled: Boolean
  };

  connect() {
    this.choicesInput = new Choices(this.choiceTarget, {
      classNames: {
        containerOuter: "choices",
      },
      searchEnabled: this.searchEnabledValue ? true : false,
      removeItemButton: this.removeItemButtonValue ? true : false,
      renderSelectedChoices: 'always',
      allowHTML: true,
      noResultsText: "Ничего не найдено",
      noChoicesText: "Ничего не найдено",
    });

    if (this.hasTogglerTarget) {
      this.isChecked = this.togglerTarget.ariaChecked;
    }
  }

  toggle(e) {
    const options = JSON.parse(this.optionsValue);
    this.choicesInput.removeActiveItems();
    if (this.isChecked === "false" || !this.isChecked) {
      this.isChecked = true;
      this.choicesInput.clearChoices();
      this.choicesInput.setValue(options);
      this.choicesInput.clearInput();
    } else {
      this.isChecked = false;
      this.choicesInput.setChoices(options, 'value', 'label', true);
    }
  }
}
